module.exports = __webpack_public_path__ + "img/ic_more_dots.35b97a3b.svg";